
export default {
    area: "",
    area_fias_id: "",
    area_kladr_id: "",
    area_type: "",
    area_type_full: "Район",
    area_with_type: "",
    beltway_distance: null,
    beltway_hit: null,
    block: "",
    block_type: "",
    block_type_full: "",
    federal_district: "",
    capital_marker: "",
    city: "",
    city_area: "",
    city_district: "",
    city_district_fias_id: "",
    city_district_kladr_id: "",
    city_district_type: "",
    city_district_type_full: "",
    city_district_with_type: "",
    city_fias_id: "",
    city_kladr_id: "",
    city_type: "",
    city_type_full: "Город",
    city_with_type: "",
    country: "",
    country_iso_code: "",
    fias_id: "",
    fias_level: "",
    flat: "",
    flat_area: null,
    flat_price: null,
    flat_type: "",
    flat_type_full: "Квартира",
    geo_lat: "",
    geo_lon: "",
    geoname_id: "",
    history_values: null,
    house: "",
    house_fias_id: "",
    house_kladr_id: "",
    house_type: "",
    house_type_full: "Дом",
    kladr_id: "",
    okato: "",
    oktmo: "",
    postal_box: "",
    postal_code: "",
    qc: null,
    qc_complete: null,
    qc_geo: "",
    qc_house: null,
    region: "",
    region_fias_id: "",
    region_kladr_id: "",
    region_type: "",
    region_type_full: "Область",
    region_with_type: "",
    settlement: "",
    settlement_fias_id: "",
    settlement_kladr_id: "",
    settlement_type: "",
    settlement_type_full: "Город",
    settlement_with_type: "",
    source: "",
    square_meter_price: null,
    street: "",
    street_fias_id: "",
    street_kladr_id: "",
    street_type: "",
    street_type_full: "Улица",
    street_with_type: "",
    tax_office: "",
    tax_office_legal: "",
    timezone: "",
    unparsed_parts: null,
    fias_code: "",
    region_iso_code: "",
    fias_actuality_state: "",
    metro: null,
};